module.exports = __webpack_public_path__ + "static/u47-fet-clone_800.cb87912f.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/photos/u47-fet-clone_800.jpg
// module id = 613
// module chunks = 0